<template>
  <b-card no-body>
    <b-card-body>
      <b-row class="d-flex align-items-center">
        <b-col>
          <b-form-group
            label="Çek Durumu"
            label-for="id_promissory_statuses"
          >
            <v-select
              id="id_promissory_statuses"
              v-model="id_promissory_statuses"
              placeholder="Çek Durumu"
              :options="promissoryStatuses"
              label="title"
              :reduce="item => item.id"
              @input="getDataList"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="auto"
        >
          <b-button
            variant="primary"
            :to="$route.path + '/add'"
          >
            <FeatherIcon icon="PlusIcon" /> Oluştur
          </b-button>
        </b-col>
      </b-row>
    </b-card-body>
    <b-table
      responsive="sm"
      :fields="fields"
      :items="dataList"
      striped
      fixed
      empty-text="Kayıt bulunamadı"
      :show-empty="dataList.length === 0"
    >
      <template #cell(title)="data">
        {{ data.item.title }}
        <div
          v-if="data.item.is_return === '1'"
          class="text-danger font-small-2"
        >
          İade Açıklaması: {{ data.item.return_notes }}
        </div>
      </template>
      <template #cell(amount)="data">
        <div v-if="data.item.amount">
          {{ data.item.amount | toCurrency }} TL
        </div>
        <div
          v-if="data.item.expiry_date"
          class="font-small-2 text-warning"
        >
          {{ moment(data.item.expiry_date).format('ll') }}
        </div>
      </template>
      <template #cell(control)="data">
        <div
          v-if="data.item.is_return !== '1'"
          class="text-right"
        >
          <list-buttons
            primary-text="Görüntüle"
            edit-text="Güncelle"
            :primary-action="$route.path + '/view/' + data.item.id"
            :edit-action="$route.path + '/edit/' + data.item.id"
            :data-id="data.item.id"
          />
        </div>
      </template>
    </b-table>
    <b-card-footer>
      <b-pagination
        v-model="currentPage"
        :total-rows="dataCounts"
        :per-page="perPage"
        first-number
        last-number
        prev-class="prev-item"
        next-class="next-item"
      >
        <template #prev-text>
          <feather-icon
            icon="ChevronLeftIcon"
            size="18"
          />
        </template>
        <template #next-text>
          <feather-icon
            icon="ChevronRightIcon"
            size="18"
          />
        </template>
      </b-pagination>
    </b-card-footer>
  </b-card>
</template>
<script>
import {
  BCard, BCardBody, BTable, BPagination, BButton, BCardFooter, BFormGroup, BRow, BCol,
} from 'bootstrap-vue'
import ListButtons from '@/layouts/components/common/ListDropdownButtons.vue'
import toastMixin from '@/libs/toast'
import vSelect from 'vue-select'

const tableName = 'promissories'
export default {
  name: 'Index',
  components: {
    BCard,
    BCardBody,
    BTable,
    BPagination,
    BButton,
    BCardFooter,
    vSelect,
    BFormGroup,
    BRow,
    BCol,
    ListButtons,
  },
  mixins: [toastMixin],
  data() {
    return {
      id_promissory_statuses: '1',
      isReturn: false,
      currentPage: 1,
      perPage: this.$store.state.app.perPage,
      fields: [
        {
          key: 'title',
          label: 'BAŞLIK',
        },
        {
          key: 'promissory_status',
          label: 'DURUM',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'amount',
          label: 'TUTAR',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
        {
          key: 'control',
          label: '',
          thClass: 'width-200 text-nowrap',
          tdClass: 'width-200 text-nowrap',
        },
      ],
      dataQuery: {
        select: [
          `${tableName}.id AS id`,
          `${tableName}.title AS title`,
          `${tableName}.amount AS amount`,
          `${tableName}.expiry_date AS expiry_date`,
          `${tableName}.is_return AS is_return`,
          `${tableName}.return_notes AS return_notes`,
          'promissory_statuses.title AS promissory_status',
        ],
        limit: this.$store.state.app.perPage,
        start: 0,
      },
    }
  },
  computed: {
    dataList() {
      return this.$store.getters['promissories/dataList']
    },
    dataCounts() {
      return this.$store.getters['promissories/dataCounts']
    },
    saveData() {
      return this.$store.getters['promissories/dataSaveStatus']
    },
    promissoryStatuses() {
      return this.$store.getters['promissoryStatuses/dataList']
    },
  },
  watch: {
    currentPage(val) {
      this.dataQuery.start = (val - 1) * this.$store.state.app.perPage
      this.getDataList()
    },
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'removeSuccess' })
      } else if (val.status === false) {
        this.showToast({ template: 'removeError' })
      }
      this.getDataList()
    },
  },
  created() {
    this.getDataList()
    this.getPromissoryStatuses()
  },
  methods: {
    getPromissoryStatuses() {
      this.$store.dispatch('promissoryStatuses/getDataList')
    },
    getDataList() {
      this.dataQuery.where = {}
      // if (!this.isReturn) {
      //   this.dataQuery.where = {
      //     'promissories.is_return': null,
      //   }
      // } else {
      //   this.dataQuery.where = {}
      // }
      if (this.id_promissory_statuses) {
        this.dataQuery.where['promissories.id_promissory_statuses'] = this.id_promissory_statuses
      }
      this.$store.dispatch('promissories/getDataList', this.dataQuery)
    },
    removeData(id) {
      this.$swal({
        title: this.$store.state.app.removeTitle,
        text: this.$store.state.app.removeMessage,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$store.state.app.removeConfirm,
        cancelButtonText: this.$store.state.app.removeCancel,
        customClass: {
          confirmButton: 'btn btn-success',
          cancelButton: 'btn btn-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.value) {
          this.$store.dispatch('promissories/removeData', id)
          this.$swal({
            icon: 'success',
            title: this.$store.state.app.removeResultTitle,
            text: this.$store.state.app.removeResultMessage,
            confirmButtonText: this.$store.state.app.removeResultClose,
            customClass: {
              confirmButton: 'btn btn-success',
            },
          })
        }
      })
    },
  },
}
</script>
